import { render, staticRenderFns } from "./Item2ColText.vue?vue&type=template&id=30e4ccdc&"
import script from "./Item2ColText.vue?vue&type=script&lang=ts&"
export * from "./Item2ColText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports